import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '24px',
    paddingBottom: '25px',
    borderBottom: '1px solid #E5E5E5',
    '&:last-child': {
      borderBottom: 0,
      marginBottom: 0,
      paddingBottom: 0,
    },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    }
  },
  rowIcon: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'flex-start',
      width: '100%',
    }
  },
  title: {
    fontWeight: 500,
    marginBottom: '12px',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '8px',
      fontSize: '18px',
    }
  },
  wrapper: {
    width: '100%',
  },
  divider: {
    marginBottom: '25px',
    height: '1px',
    backgroundColor: '#e2ebf6',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '15px',
    }
  },
  deleteIcon: {
    fontSize: '23px',
    marginTop: '15px',
    [theme.breakpoints.down('sm')]: {
      marginTop: '10px',
      fontSize: '20px',
    }
  }
}));
